import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
    return (
        <InputPrimitive
            type={type}
            data-slot="input"
            className={cn(
                "w-full h-10 px-2.5 rounded-[var(--color-radius)] border border-md-outline bg-md-surface text-md-on-surface text-sm outline-none focus:border-md-primary focus:ring-[3px] focus:ring-md-primary/20 transition-all",
                "hover:border-md-primary hover:bg-md-tertiary-container/10",
                "placeholder:text-gray-600",
                "disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-md-surface-variant disabled:text-md-on-surface-variant disabled:border-md-outline-variant",
                "aria-invalid:border-md-error aria-invalid:bg-md-error/5",
                className,
            )}
            {...props}
        />
    );
}

export { Input };
